import { namespace as LocationsNamespace } from '@store/modules/locations.types';

import InputMessagesApiService from './_services/inputMessages.service';

import { MutationTypes, ActionTypes } from './store.types';

export { namespace } from './store.types';

export default {
  namespaced: true,
  state: {
    inputMessage: {},
    inputMessages: [],
  },
  mutations: {
    [MutationTypes.SET_INPUT_MESSAGE](state, payload) {
      state.inputMessage = payload;
    },
    [MutationTypes.SET_INPUT_MESSAGES](state, payload) {
      state.inputMessages = payload;
    },
  },
  actions: {
    async [ActionTypes.GET_INPUT_MESSAGE](
      { commit, rootState: { [LocationsNamespace]: l } },
      { suffix = l.suffix, id },
    ) {
      commit(
        MutationTypes.SET_INPUT_MESSAGE,
        await InputMessagesApiService.getInputMessage({ suffix, id }),
      );
    },
    async [ActionTypes.GET_INPUT_MESSAGES](
      { commit, rootState: { [LocationsNamespace]: l } },
      { suffix = l.suffix, pageNum = 1, ...rest },
    ) {
      commit(
        MutationTypes.SET_INPUT_MESSAGES,
        await InputMessagesApiService.getInputMessages({ suffix, pageNum, ...rest }),
      );
    },
  },
};
